module.exports = __webpack_public_path__ + "img/logo.7155e85c.svg";